import { useEffect, useRef } from 'react';
import { getProperty } from '@/common/oldMobile';
import { getConfigProperty } from '@/common/oldMobile';
import addDOMScript from '@/common/deferSdk/domUtil';

const localeMap = {
    sk: 'sk_SK',
    en: 'en_US',
    hu: 'hu_HU'
};

let fbSdkPromise;

export const useXFBML = function() {
    const parseContainer = useRef();
    useEffect(() => {
        deferFbSdk(FB => FB.XFBML.parse(parseContainer.current));
    }, []);
    return parseContainer;
};

function deferFbSdk(fn) {
    if (!fbSdkPromise) {
        fbSdkPromise = new Promise(resolve => {
            window.fbAsyncInit = function() {
                console.log('window.FB.init');
                window.FB.init({
                    appId: getConfigProperty('facebook.key'),
                    xfbml: false,
                    version: 'v3.3'
                });
                resolve(window.FB);
            };

            let locale = localeMap[getProperty('locale')];
            locale = locale ? locale : localeMap.sk;
            const sdkUrl = `//connect.facebook.net/${locale}/sdk.js`;
            addDOMScript('facebook-jssdk', sdkUrl);
        });
    }
    return fbSdkPromise.then(FB => (FB ? FB : Promise.reject('window.FB not defined'))).then(fn);
}
